// This file was auto-generated by Fern from our API Definition.
/** What the server asked for, as far as the probe could establish. */
export const McpProbeAuthMode = {
    None: "none",
    Oauth: "oauth",
    Unknown: "unknown",
};
